export default __webpack_public_path__ + "static/media/recipe-book.26871c85.svg";